var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Notifications',{attrs:{"isMobile":_vm.isMobile,"initialTab":"sent","inPage":true,"data-component-name":_vm.$options.name},on:{"set-current-date":function($event){return _vm.$emit('set-current-date', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }